<template>
	<div class="tpl my-gifts-wrap">
		<mt-header title="我的礼物" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button class="header-right-btn" slot="right" @click.native="toAllCash">全部提现</mt-button>
		</mt-header>
		<div class="gifts-header">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">我收到的<span v-if="selected==1">({{myAcceptGiftsList.sum||0}})</span><span class="active-dot"></span></mt-tab-item>
				<mt-tab-item id="2">我送出的<span v-if="selected==2">({{mySendGiftsList.sum||0}})</span><span class="active-dot"></span></mt-tab-item>
			</mt-navbar>
		</div>
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1">
				<div class="gift-list">
					<ul>
						<li v-for="item in myAcceptGiftsList.gift" @click="showGiftDetail(item)">
							<img :src="item.girft_img_url" alt="" />
							<p class="item-name">{{item.girft_name}}</p>
							<p class="item-num">{{item.g_nums}}</p>
						</li>
					</ul>
					<div class="no-content" v-if="myAcceptGiftsList.sum==0">
						<img src="../../assets/img/default/bg_img_nothing@2x.png" alt="" />
						<p>(〒▽〒) 这里空空哒~</p>
						<button>提高我的展示机会</button>
					</div>
				</div>
			</mt-tab-container-item>
			<mt-tab-container-item id="2">
				<div class="send-list">
					<ul>
						<li v-for="item in mySendGiftsList.gift">
							<div class="item-avatar">
								<img :src="item.avatar"/>
							</div>
							<div class="item-text">
								<p>我赠送给</p>
								<p class="item-name">
									{{item.nickname}}
									<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
									<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
									<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
								</p>
								<p class="item-time">{{item.create_time | toDateTime | convertTime("YYYY-MM-DD")}}</p>
							</div>
							<div class="item-gift">
								<div class="gift-show">
									<img :src="item.girft_img_url" alt="" />
									<p>{{item.girft_name}}</p>
								</div>
								<span class="gift-num">
									&times;{{item.g_nums}}
								</span>
							</div>
						</li>
					</ul>
					<div class="no-content" v-if="mySendGiftsList.sum==0">
						<img src="../../assets/img/default/bg_img_nothing@2x.png" alt="" />
						<p>(〒▽〒) 这里空空哒~</p>
					</div>
				</div>
			</mt-tab-container-item>
			
		</mt-tab-container>
		 <transition name="fade">
		<div class="gift-detail-wrap" v-if="showDetail" @click.self="showDetail=0">
			<div class="gift-detainer-inner">
				<p class="detail-title">礼物详情</p>
				<div class="detail-user">
					<div class="user-info">
						<div class="user-img"><img :src="giftDetail.avatar"/></div>
					</div>
					<div class="user-text">
						<p class="user-name">
							{{giftDetail.nickname}}
							<img v-if="giftDetail.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
							<img v-if="giftDetail.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
							<img v-if="giftDetail.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
						</p>
						<p class="user-time">{{giftDetail.create_time}}</p>
					</div>
					<div class="user-option">
						<p class="send-gift"><button>给他回礼</button></p>
						<p class="send-message"><button>发消息</button></p>
					</div>
				</div>
				<div class="gift-info">
					<div class="gift-text">
						<p>赠送礼物：<span>{{giftDetail.girft_name}}&times;{{giftDetail.g_nums}}</span>给你</p>
						<p>价值：<span>{{giftDetail.price}}桃花币</span></p>
					</div>
					<div class="gift-img">
						<img :src="giftDetail.girft_img_url" alt="" />&times;20
					</div>
				</div>
				<div class="detail-tip">
					<p>提示：线下所获得的虚拟礼物，均可选择兑换成线下真实物品或线上提现哦~</p>
				</div>
				<div class="detail-option">
					<p class="to-exchange"><button @click="toExchange()">去兑换</button></p>
					<p class="to-cash"><button @click="toCash()">去提现</button></p>
				</div>
			</div>
			
		</div>
		</transition>
	</div>
</template>

<script>
	
	export default{
		name:"my-gifts",
		data(){
			return{
				uid:"",
				selected:"1",
				myAcceptGiftsList:[],
				acceptNowPage:1,
				mySendGiftsList:[],
				sendNowPage:1,
				giftDetail:"",
				showDetail:0,
				gInfo:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getMyAcceptGifts();
			this.getMySendGifts();
		},
		methods:{
			getMyAcceptGifts(){
				this.$axios({
					url:"My/UserReceiveGiftsnAllList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.acceptNowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.myAcceptGiftsList = res.data.data
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getMySendGifts(){
				this.$axios({
					url:"My/UserGiveGiftsnAllList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.sendNowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.mySendGiftsList = res.data.data
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			showGiftDetail(item){
				console.log(item);
				this.giftDetail = item;
				this.showDetail = 1;
			},
			toExchange(){
				this.$router.push({
					name:"gift-exchange",
					query:{
						gid:this.giftDetail.g_id,
						num:this.giftDetail.g_nums,
						type:this.giftDetail.type
					}
				})
			},
			toCash(){
				this.$router.push({
					name:"gift-cash",
					query:{
						gid:this.giftDetail.g_id,
						num:this.giftDetail.g_nums,
						type:this.giftDetail.type,
						price:this.giftDetail.price,
						integral:null
					}
				})
			},
			toAllCash(){
				this.$router.push({
					name:"gift-all-cash"
				})
			}
		}
	}
</script>

<style scoped>
	
	.my-gifts-wrap{
		padding-top: 5.5rem;
	}
	.header-right-btn >>>label{
		color: #5415F9;
	}
	.gifts-header{
		border-bottom: 1px solid #f3f3f3;
		position: fixed;
		width: 100%;
		top: 2.5rem;
		left: 0;
		z-index: 10;
		background: #fff;
	}
	.mint-navbar {
	    width: 60%;
    	padding: 0 0.5rem;
	}
	>>>.mint-navbar .mint-tab-item {
		box-sizing: border-box;
		position: relative;
	}
	.active-dot{
	    display: none;
	    width: 5px;
	    height: 5px;
	    background: #6D34FB;
	    border-radius: 50%;
	    position: absolute;
	    left: 50%;
	    bottom: 0.4rem;
	}
	>>>.mint-tab-item.is-selected .mint-tab-item-label {
		font-size: 1rem;
		font-weight: bold;
		color: #282828;
	}
	>>>.mint-tab-item.is-selected .active-dot{
		display: block;
	}
	>>>.mint-navbar .mint-tab-item.is-selected {
		border-bottom: 0;
	}
	
	.gifts-list .no-content{border-top: 1px solid #f3f3f3;}
	
	.gift-list ul{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		background: #fff;
	}
	.gift-list li{
		width: 33%;
		text-align: center;
		padding: 0.2rem 0;
		background: #fff;
	}
	.gift-list li:active{
		background: #fafafa;
	}
	.gift-list li img{
		width: 3rem;
		display: inline-block;
		margin: 0.2rem;
	}
	.gift-list li .item-name{
		font-size: 0.9rem;
		color: #282828;
	}
	.gift-list li .item-num{
		font-size: 0.7rem;
		color: #7b7b7b;
	}
	
	.send-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0.5rem;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.send-list li:active{
		background: #fafafa;
	}
	.send-list li .item-avatar{
		width: 2.8rem;
		height: 2.8rem;
		border-radius: 50%;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f4f4f4;
	}
	.send-list li .item-avatar img{
		width: 2.8rem;
	}
	.send-list li .item-text{
		flex: 1;
		padding: 0 0.5rem;
	}
	.send-list li .item-text p:first-of-type{
		font-size: 0.8rem;
		color: #5415F9;
	}
	.send-list li .item-name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.send-list li .item-name img{
		width: 1.5rem;
		margin-left: 0.2rem;
	}
	.send-list li .item-time{
		font-size: 0.8rem;
		color: #7b7b7b;;
	}
	.send-list li .item-gift{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.send-list li .item-gift .gift-show{
		text-align: center;
		font-size: 0.8rem;
		color: #282828;
	}
	.send-list li .item-gift img{
		width: 3rem;
	}
	.send-list li .item-gift .gift-num{
		font-size: 0.8rem;
		color: #7b7b7b;
		width: 1.5rem;
		text-align: center;
	}
	
	.gift-detail-wrap{
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		background: rgba(0,0,0,.3);
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		transition: 500ms;
	}
	.gift-detail-wrap .gift-detainer-inner{
		width: 100%;
		background: #fff;
		border-radius: 1rem 1rem 0 0;
	}
	.gift-detail-wrap .detail-title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		text-align: center;
		line-height: 2rem;
		padding: 0.5rem 1rem;
	}
	.gift-detail-wrap .detail-user{
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #f3f3f3;
	}
	.gift-detail-wrap .detail-user .user-img{
		width: 3rem;
		height: 3rem;
		border-radius: 50%;
		overflow: hidden;
	}
	.gift-detail-wrap .detail-user .user-img img{
		width: 3rem;
	}
	.gift-detail-wrap .detail-user .user-text{
		flex: 1;
		padding: 0 0.5rem;
	}
	.gift-detail-wrap .detail-user .user-name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		line-height: 1.8rem;
	}
	.gift-detail-wrap .detail-user .user-name img{
		width: 1.5rem;
	}
	.gift-detail-wrap .detail-user .user-time{
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.6rem;
	}
	.gift-detail-wrap .user-option button{
		width: 5rem;
		border-radius: 3rem;
		border: 0;
		background: none;
		outline: 0;
		margin: 0.2rem;
		font-size: 0.8rem;
		padding: 0.2rem 0;
	}
	.gift-detail-wrap .user-option .send-gift button{
		border: 1px solid #ff6161;
		color: #ff6161;
	}
	.gift-detail-wrap .user-option .send-message button{
		background: #ff6161;
		color: #fff;
	}
	.gift-detail-wrap .gift-info{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 1rem;
		font-size: 0.8rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.5rem;
	}
	.gift-detail-wrap .gift-text p span{
		color: #5415F9;
		margin: 0 0.2rem;
		font-weight: normal;
	}
	.gift-detail-wrap .gift-img{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.7rem;
		color: #7b7b7b;
		font-weight: normal;
	}
	.gift-detail-wrap .gift-img img{
		width: 3rem;
		margin-right: 0.5rem;
	}
	.gift-detail-wrap .detail-tip{
		font-size: 0.8rem;
		color: #5415F9;
		background: rgba(78,5,255,.05);
		padding: 0.5rem 1rem;
		opacity: 0.8;
	}
	.gift-detail-wrap .detail-option{
		padding: 1rem 1.5rem;
	}
	.gift-detail-wrap .detail-option p{
		padding: 0.5rem 0;
	}
	.gift-detail-wrap .detail-option p button{
		width: 100%;
		height: 2.5rem;
		font-size: 0.8rem;
		border: 0;
		outline: 0;
		background: none;
		border-radius: 4px;
	}
	.gift-detail-wrap .detail-option p.to-exchange button{
		border: 1px solid #4E05FF;
		color: #5415F9;
	}
	.gift-detail-wrap .detail-option p.to-cash button{
		color: #fff;
		background: linear-gradient(45deg,rgba(118,68,250,1) 0%,rgba(156,124,255,1) 100%);
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyGifts.vue